import { RETRO_CLAIM_PAYMENT_MODE } from "constants/global";

export const PAYMENT_MODE_OPTIONS = [RETRO_CLAIM_PAYMENT_MODE.MASTERCARD, RETRO_CLAIM_PAYMENT_MODE.OTHERS] as const;

// Maps API payment mode values to dropdown labels shown in the form.
export const normalizePaymentMode = (paymentMode?: string): string => {
	if (!paymentMode?.trim()) {
		return "";
	}

	const apiValue = paymentMode.trim().toUpperCase();

	if (apiValue === "MASTERCARD") {
		return RETRO_CLAIM_PAYMENT_MODE.MASTERCARD;
	}

	if (apiValue === "OTHERS") {
		return RETRO_CLAIM_PAYMENT_MODE.OTHERS;
	}

	return "";
};

// Formats payment mode for backend API requests.
export const formatPaymentModeForApi = (paymentMode?: string): string => {
	return paymentMode?.trim().toUpperCase() ?? "";
};
